"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonText = exports.SkeletonCircle = exports.Skeleton = void 0;
var _react = _interopRequireDefault(require("react"));
var _skeletonBase = _interopRequireDefault(require("./skeleton-base"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
} /* eslint react/function-component-definition: 0 */
var Skeleton = exports.Skeleton = function Skeleton(props) {
  return /*#__PURE__*/_react["default"].createElement(_skeletonBase["default"], _extends({
    variant: "rect"
  }, props));
};
var SkeletonText = exports.SkeletonText = function SkeletonText(props) {
  return /*#__PURE__*/_react["default"].createElement(_skeletonBase["default"], _extends({
    variant: "text"
  }, props));
};
var SkeletonCircle = exports.SkeletonCircle = function SkeletonCircle(props) {
  return /*#__PURE__*/_react["default"].createElement(_skeletonBase["default"], _extends({
    variant: "circle"
  }, props));
};